import { createContext } from "react";

const WhatsAppKeyContext = createContext({});

export default WhatsAppKeyContext;
